export enum EBuildingType {
  Residential,
  Commercial,
  None,
}
